<template>
  <div>
    <a-modal v-model="visible" title="Vehicle-Students-Routes" onOk="handleOk"
      :width="this.settings['isMobileView'] ? 360 : this.settings['isTabletView'] ? 560 : 1080"
    >
      <template slot="footer">
        <a-button key="back" type="primary" @click="handleCancel">Close</a-button>
        <!-- <a-button key="submit" type="primary" :loading="loading" @click="">Edit</a-button> -->
      </template>
      <a-spin :spinning="spinning">
      <div v-if="record">

      <div class="row align-items-center">
        <div class="col-md-12">
          <h5 class="font-weight-bold mb-0">Vehicle No: {{record.vehicle_no}}</h5>
          <p>
            <span class="pr-2">Registration No:</span> <span class="font-weight-bold px-2">{{record.registration_no}}</span>|
            <span class="px-2">Vehicle Type:</span> <span class="font-weight-bold px-2">{{record.vehicle_type}}</span>|
            <span class="px-2">Driver:</span> <span class="font-weight-bold px-2">{{record.driver.first_name}} {{record.driver.last_name}}</span>|
            <span class="px-2">Driver ID:</span> <span class="font-weight-bold px-2">{{record.driver.staff_id}}</span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h5 class="font-weight-bold px-2">Routes:</h5>
        </div>
      </div>
      <hr class="m-0">
      <a-table
        :rowKey="record => record.id"
        :columns="routeColumns"
        :dataSource="record.routes"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading">
        <template slot="No" slot-scope="record">
          <div class="text-wrap">
            <div class="text-wrap">{{oldrecord.routes.indexOf(record) + 1}}</div>
          </div>
        </template>
    </a-table>

    <div class="row">
        <div class="col-md-12">
          <p></p><p></p>
          <h5 class="font-weight-bold px-2">Students:</h5>
        </div>
    </div>
    <hr class="m-0">
      <a-table
        :rowKey="record => record.id"
        :columns="studentColumns"
        :dataSource="record.students"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading">
        <template slot="No" slot-scope="record">
          <div class="text-wrap">
            <div class="text-wrap">{{oldrecord.students.indexOf(record) + 1}}</div>
          </div>
        </template>
        <template slot="student_name" slot-scope="record">
          <div class="text-wrap">
            <div class="text-wrap">{{record.first_name +' '+ record.last_name}}</div>
          </div>
        </template>
        <!-- <template slot="class" slot-scope="record">
          <div class="text-wrap">
            <div class="text-wrap">{{record.enrollment.school_classes.name}}</div>
          </div>
        </template>
        <template slot="section" slot-scope="record">
          <div class="text-wrap">
            <div class="text-wrap">{{record.enrollment.section.name}}</div>
          </div>
        </template> -->
      </a-table>

        <div>
          <p style="margin-bottom: 2px; width: 100%">
            <!-- <span class="pr-2"><b>Paid by: </b>{{record.paid_by}}</span> -->
            <!-- <span class="pr-2 float-right"><b>Created by: </b> {{record.created_by.first_name}} {{record.created_by.last_name}}</span> -->
          </p>
          <!-- <p style="margin-bottom: 2px;"><span class="pr-2"><b>Remark: </b>{{record.remark}}</span></p> -->
        </div>
    </div>
      </a-spin>
<!--      <a-spin :spinning="spinning">
        <div v-if="student && studentFeeData">
          <pay-history :studentFeeData="studentFeeData" :student="student" :schoolData="schoolData" id="feePaymentMistory"/>
        </div>
      </a-spin>-->
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

const routeColumns = [
  { title: 'Sl.No.', width: 50, scopedSlots: { customRender: 'No' } },
  { title: 'Route No.', width: 100, dataIndex: 'route_no', scopedSlots: { customRender: 'route_no' } },
  { title: 'Route Name', width: 150, dataIndex: 'route_name', scopedSlots: { customRender: 'route_name' } },
  { title: 'Location', width: 300, dataIndex: 'location', scopedSlots: { customRender: 'location' } },
  //  { title: 'Actions', width: 210, className: 'text-right', scopedSlots: { customRender: 'action' } },
]

const studentColumns = [
  { title: 'Sl.No.', width: 50, scopedSlots: { customRender: 'No' } },
  { title: 'Code', width: 50, dataIndex: 'student_code', scopedSlots: { customRender: 'student_code' } },
  { title: 'Name', width: 100, scopedSlots: { customRender: 'student_name' } },
  { title: 'Class', width: 100, dataIndex: 'enrollment[0].school_classes.name', scopedSlots: { customRender: 'enrollment[0].school_classes.name' } },
  { title: 'Section', width: 100, dataIndex: 'enrollment[0].section.name', scopedSlots: { customRender: 'enrollment[0].section.name' } },

  { title: 'Pickup Point', width: 100, dataIndex: 'transport_pickup_point', scopedSlots: { customRender: 'transport_pickup_point' } },
]

function onChange(sorter) {
  console.log('params', sorter)
}

export default {
  name: 'VehicleDetails',
  components: {
  },
  props: {
    isPublic: {
      default: false,
    },
    schoolData: {
      default: null,
    },
  },
  data: function() {
    return {
      // form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      dateFormat: 'DD-MM-YYYY',
      record: null,
      oldrecord: [],
      routeColumns,
      studentColumns,
      selectedRowKeys: [],
    }
  },
  mounted: function () {
    this.$eventBus.$on('openViewVehicleDetailsModal', this.showModal)
  },
  computed: {
    ...mapState(['settings', 'user']),
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    moment,
    showModal: function(record) {
      console.log('inside openViewVehicleDetailsModal')
      console.log('vehicleDetails:: ', record)
      this.visible = true
      this.spinning = true
      this.record = record
      this.oldrecord = record
      this.spinning = false
      // this.getOrderDetails(record)
    },
    getOrderDetails: function (record) {
      this.$http
        .get('/api/library/book/loans/' + record.id)
        .then(({ data }) => {
          this.spinning = false
          this.record = data.data
        })
        .catch(error => {
          this.$nprogress.done()
          this.$neoNotify.error(error)
        })
    },
    serialNo: function (record) {
      console.log('serial no: ', record)
      // record.indexOf(record.id)
    },
    onChange,
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      console.log('selectedKeys: ', selectedRowKeys)

      this.$emit('selectChange', selectedRowKeys)
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}

</script>
